import React from 'react'
import { IIconProps } from 'Interfaces'

export function GridViewIcon(props: IIconProps) {
    return (        
        <svg width={props.width ?? 16} height={props.height ?? 16} viewBox='0 0 24 24' fill={props.color ?? "currentColor"}>
            <path d="M1.84619 16.613V22.1514H7.38465V16.613H1.84619ZM5.5385 20.3053H3.69235V18.4591H5.5385V20.3053Z" />
            <path d="M1.84619 9.22836V14.7668H7.38465V9.22836H1.84619ZM5.5385 12.9207H3.69235V11.0745H5.5385V12.9207Z" />
            <path d="M1.84619 1.84375V7.38221H7.38465V1.84375H1.84619ZM5.5385 5.53606H3.69235V3.6899H5.5385V5.53606Z" />
            <path d="M9.23081 16.613V22.1514H14.7693V16.613H9.23081ZM12.9231 20.3053H11.077V18.4591H12.9231V20.3053Z" />
            <path d="M9.23081 9.22836V14.7668H14.7693V9.22836H9.23081ZM12.9231 12.9207H11.077V11.0745H12.9231V12.9207Z" />
            <path d="M9.23081 1.84375V7.38221H14.7693V1.84375H9.23081ZM12.9231 5.53606H11.077V3.6899H12.9231V5.53606Z" />
            <path d="M16.6154 16.613V22.1514H22.1539V16.613H16.6154ZM20.3077 20.3053H18.4616V18.4591H20.3077V20.3053Z" />
            <path d="M16.6154 9.22836V14.7668H22.1539V9.22836H16.6154ZM20.3077 12.9207H18.4616V11.0745H20.3077V12.9207Z" />
            <path d="M16.6154 1.84375V7.38221H22.1539V1.84375H16.6154ZM20.3077 5.53606H18.4616V3.6899H20.3077V5.53606Z" />
        </svg>
    )
}
